var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkingTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9791 30C6.69456 30 0 23.3054 0 15.0209C0 6.7364 6.69456 0 14.9791 0C23.2636 0 30 6.7364 30 15.0209C30 23.3054 23.2636 30 14.9791 30ZM14.9791 3.72385C8.78661 3.72385 3.76569 8.82845 3.76569 15.0209C3.76569 21.2134 8.78661 26.2343 14.9791 26.2343C21.1715 26.2343 26.2761 21.2134 26.2761 15.0209C26.2761 8.82845 21.1715 3.72385 14.9791 3.72385ZM19.0377 20.7531L13.7238 16.8619C13.3473 16.569 12.9707 15.9414 12.9707 15.4393V6.94561C12.9707 6.48536 13.3891 6.10879 13.8912 6.10879H15.6485C16.1088 6.10879 16.4854 6.48536 16.4854 6.94561V13.6402C16.4854 14.1423 16.8619 14.7699 17.2385 15.0628L21.1297 17.8661C21.5063 18.159 21.59 18.7448 21.2971 19.1213L20.251 20.5439C19.9582 20.9205 19.4142 21.0042 19.0377 20.7531Z",
    fill: "url(#paint0_linear_461_1087)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_461_1087",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#49C8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33DA8A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkingTime);
export default __webpack_public_path__ + "static/media/working_time.fa2d65b2.svg";
export { ForwardRef as ReactComponent };